const typePolicies = {
    
    Settings: {
        merge: false
    }
    
}
export default typePolicies